"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPathnameFromUri = void 0;
var getPathnameFromUri = function (uri) {
    var urlParsed = new URL(uri);
    return urlParsed.pathname;
};
exports.getPathnameFromUri = getPathnameFromUri;
